"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.dismissToast = dismissToast;
exports.toastEmitter = toastEmitter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _reactToastify = require("react-toastify");
var _toast = require("./toast.style");
var _Icon = _interopRequireDefault(require("../Icon"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Toast = _a => {
  var {
      className = 'toast',
      title,
      description,
      limit
    } = _a,
    rest = __rest(_a, ["className", "title", "description", "limit"]);
  return (0, _jsxRuntime.jsxs)(_toast.Components.Container, (0, _extends2["default"])({
    className: className
  }, rest, {
    limit: limit
  }, {
    children: [(0, _jsxRuntime.jsx)(_Icon["default"], {
      name: "info-circle"
    }), (0, _jsxRuntime.jsxs)(_toast.Components.Content, {
      children: [(0, _jsxRuntime.jsx)(_toast.Components.Heading, {
        children: title
      }), (0, _jsxRuntime.jsx)(_toast.Components.Body, {
        children: description
      })]
    }), (0, _jsxRuntime.jsx)(_toast.Components.CloseButton, {
      children: (0, _jsxRuntime.jsx)(_Icon["default"], {
        name: "times"
      })
    })]
  }));
};
function toastEmitter(_a, options) {
  var {
      title,
      description
    } = _a,
    rest = __rest(_a, ["title", "description"]);
  if (options && options.type !== 'info') {
    if (options === null || options === void 0 ? void 0 : options.toastId) {
      // eslint-disable-next-line no-console
      console.log('isActive', _reactToastify.toast.isActive(options.toastId));
    }
    if (options.type === 'success') {
      return _reactToastify.toast.success((0, _jsxRuntime.jsx)(Toast, (0, _extends2["default"])({
        title: title,
        description: description
      }, rest)), options);
    } else if (options.type === 'error') {
      return _reactToastify.toast.error((0, _jsxRuntime.jsx)(Toast, (0, _extends2["default"])({
        title: title,
        description: description
      }, rest)), options);
    } else if (options.type === 'warning') {
      return _reactToastify.toast.warning((0, _jsxRuntime.jsx)(Toast, (0, _extends2["default"])({
        title: title,
        description: description
      }, rest)), options);
    }
  }
  return (0, _reactToastify.toast)((0, _jsxRuntime.jsx)(Toast, (0, _extends2["default"])({
    title: title,
    description: description
  }, rest)), options);
}
/**
 * Removes the toast based on Id or all toasts
 * @param {string} dismissToastId The toast id that has to be removed.
 */
function dismissToast(dismissToastId) {
  if (dismissToastId) {
    _reactToastify.toast.dismiss(dismissToastId);
  } else {
    _reactToastify.toast.dismiss();
  }
}
const ToastContainer = _ref => {
  let {
    limit,
    style
  } = _ref;
  return (0, _jsxRuntime.jsx)(_toast.Components.ToastContainer, {
    limit: limit,
    style: style
  });
};
var _default = exports["default"] = ToastContainer;